import axios from 'axios';

import {Prospect} from 'types';

import {API_URL} from './constants';

type ConfirmProspectOptions = {
    token: string;
    password: string;
    confirmPassword: string;
    timeZone: string;
}

const confirmProspect = (data: ConfirmProspectOptions) => axios.post(`${API_URL}/prospect/confirm`, data);

const getProspect = async (token: string): Promise<{prospect: Prospect, userExists: boolean}> => {
    const response = await axios.get(`${API_URL}/prospect/${token}`);
    return response.data;
};

const getUpgradeToken = async (): Promise<{token: string}> => {
    const response = await axios.get(`${API_URL}/prospect/upgrade-token`);
    return response.data;
};

export const prospectApi = {
    confirmProspect,
    getUpgradeToken,
    getProspect
};